export default __webpack_public_path__ + "static/media/logo-yclick.a4515eec.svg";